export default __webpack_public_path__ + "static/media/tooth (2)1.be73200b.png";